<template>
  <v-card v-if="show" class="proposal grey darken-3 white--text">
    <div class="proposal_icon"></div>
    <div class="proposal_description">
      <h3>Приложение VladLink</h3>
      <p>Управляйте услугами интернета и ТВ на Вашем смартфоне.</p>
    </div>
    <div class="proposal_button">
      <v-btn small @click="navigate" :href="appLink">Открыть</v-btn>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'MobileAppProposal',

    data() {
      return {
        show: false,
        doShowAppProposal: true,
        userAgent: this.getMobileSystem(),
        appLink: 'https://vladlink.page.link/my?utm_source=pay.vladlink.ru',
      };
    },

    created() {
      if (this.userAgent) {
        const isAppViewed = sessionStorage.getItem('isAppViewed');
        this.show = !!!isAppViewed;
      }
    },

    methods: {
      navigate() {
        sessionStorage.setItem('appViewed', '1');
        this.show = false;
      },

      getMobileSystem() {
        const userAgent = navigator.userAgent || navigator.vendor;

        if (/android/i.test(userAgent)) {
          return 'Android';
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return 'iOS';
        }

        return null;
      },
    },
  };
</script>

<style scoped>
  .proposal {
    position: relative;
    margin: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
  }

  .proposal_icon {
    border-radius: 10px !important;
    width: 50px;
    min-width: 50px;
    height: 50px;
    background: url("/static/logo_mobile.png") no-repeat;
    background-size: contain;
  }

  .proposal_description {
    font-size: 12px;
    line-height: 14px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .proposal_description p {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileAppProposal.vue